
        var result = require("!!../../../../../node_modules/css-loader/index.js!./environment.banner.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/layouts/environment.banner.css
// module id = 271
// module chunks = 0